import { RoutePath, type RoutePaths } from "@/lib/routes"
import { DASHBOARD_ROOT_URL } from "../constants/dashboardRootUrl"

const personalDetailsRootPath = RoutePath.create(`/${DASHBOARD_ROOT_URL}/informations-personnelles`)

export const personalDetailsRoutesPaths = {
    personalDetails: personalDetailsRootPath,
    contactDetails: personalDetailsRootPath.create("/coordonnees"),
    addAccountUser: personalDetailsRootPath.create("/nouvel-occupant"),
    communicationPreferences: personalDetailsRootPath.create("/preferences-de-communication"),
    security: personalDetailsRootPath.create("/securite"),
    developerSettings: personalDetailsRootPath.create("/votre-cle-api"),
} as const satisfies RoutePaths
